import './Spinner.css';

interface SpinnerProps {
  size?: number;
  className?: string;
}

export default function Spinner({ size = 100, className = '' }: SpinnerProps) {
  return (
    <>
      <svg className="svg-filter" aria-hidden="true">
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="6" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      0 0 0 50 -16"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>
      <div className={`spinner-wrapper ${className}`} style={{ width: size, height: size }}>
        <div className="spinner" style={{ width: size, height: size }}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </>
  );
}

